import { Alert, AlertColor, AlertProps, Button } from '@mui/material'
import { Announcement } from '../types'
import Markdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

interface AnnouncementAlertProps extends Omit<AlertProps, 'severity'> {
  announcement: Announcement
}

const AnnouncementAlert: React.FC<AnnouncementAlertProps> = ({ announcement, sx, ...props }) => {
  /**
   * Indicates whether the announcement has a URL.
   */
  const hasUrl =
    Object.keys(announcement.customData).length > 0 &&
    announcement.customData.url !== '' &&
    announcement.customData.urlName !== ''

  /**
   * Parse the URL-address.
   */
  const parseUrl = (url: string) => {
    return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www')
      ? url
      : `https://${url}`
  }

  /**
   * Open the URL in a new tab.
   */
  const openUrlInNewTab = (url: string) => {
    window?.open(url, '_blank')?.focus()
  }

  return (
    <Alert
      variant="filled"
      severity={announcement.severity as AlertColor}
      sx={{
        '& p': {
          margin: 0
        },
        '& a': {
          color: 'white',
          fontWeight: 700,
          textDecoration: 'underline'
        },
        ...sx
      }}
      {...props}
    >
      {/* @ts-expect-error typed incorrectly */}
      <Markdown rehypePlugins={[rehypeRaw]}>{announcement.message}</Markdown>
      {hasUrl && (
        <Button
          color="inherit"
          variant="outlined"
          size="small"
          sx={{ mt: 2 }}
          onClick={() => openUrlInNewTab(parseUrl(announcement.customData.url))}
        >
          {announcement.customData.urlName}
        </Button>
      )}
    </Alert>
  )
}

export default AnnouncementAlert
